<template>
    <!--    <iframe src="https://www.pgsoft.com/masthead/leprechaun-riches.html?language=en" frameborder="0"></iframe>-->
    <!--    <div class="container">-->
    <!--      <div class="btn" v-for="game in $dataManager.getters.games" >-->
    <!--        <router-link :to="{ name: game.category}">-->
    <!--          {{game.category}}-->
    <!--        </router-link>-->
    <!--      </div>-->
    <!--    </div>-->
    <router-view ></router-view>
</template>

<script>
  export default {
    name: "Game",
    data: function () {
      return {
        url: ''
      }
    },
    computed: {
      route() {
        return this.$route.name
      }
    },
  }
</script>

<style lang="scss">
  iframe {
    width: 100%;
    height: 685px;
  }

  .btn {
    width: 50px;
    height: 50px;
    background-color: #ff2970;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
